import React from "react";
import "./styles.scss";

const buildClassName = props => {
  var className = "nalu-text"
  if (props.left) { className += " left" }
  if (props.right) { className += " right" }
  if (props.center) { className += " center" }
  return className
}

export default props => {
  let onClickAction = props.onClick
  return (
      <div className="text">
        { props.h1 && <h1 className={buildClassName(props)}>{props.text}</h1> }
        { props.h2 && <h2 className={buildClassName(props)}>{props.text}</h2> }
        { props.h3 && <h3 className={buildClassName(props)}>{props.text}</h3> }
        { props.h4 && <h4 className={buildClassName(props)}>{props.text}</h4> }
        { props.h5 && <h5 className={buildClassName(props)}>{props.text}</h5> }
        { props.h6 && <h6 className={buildClassName(props)}>{props.text}</h6> }
        { props.p && <p className={buildClassName(props)}>{props.text}</p> }
        { props.footer && <footer className={buildClassName(props)}>{props.text}</footer> }
        { props.href && <a className={buildClassName(props)} href={props.href} onClick={ e => {
          e.preventDefault()
          onClickAction()
        }}>{props.text}</a> }
      </div>
  );
};
